import { TYPES } from "./income.type";

const initState = {
  all: null,
  income: null,
};

const incomeReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_ALL_SUCCESS:
      return {
        ...state,
        all: payload,
      };
    case TYPES.SELECT_ALL_INCOME_SUCCESS:
      return {
        ...state,
        income: payload,
      };

    default:
      return state;
  }
};

export default incomeReducer;
